import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Editar ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Sim ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Não ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Ativo ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Desativado ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CreateOutline = _resolveComponent("CreateOutline")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_n_switch = _resolveComponent("n-switch")!
  const _component_n_form = _resolveComponent("n-form")!
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_n_button, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal())),
      type: "warning",
      size: "small"
    }, {
      icon: _withCtx(() => [
        _createVNode(_component_n_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_CreateOutline)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_n_modal, {
      show: _ctx.showModal,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showModal) = $event)),
      "mask-closable": false,
      class: "w-full md:w-1/2",
      preset: "dialog",
      title: `Editar subgrupo ${_ctx.data.titulo}`,
      "positive-text": "Atualizar",
      onPositiveClick: _ctx.updateData
    }, {
      default: _withCtx(() => [
        _createVNode(_component_n_form, {
          ref: "formRef",
          model: _ctx.model,
          "label-placement": "left",
          "label-width": 160,
          class: "mt-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_n_form_item, {
              label: "Título",
              path: "titulo"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_input, {
                  value: _ctx.model.titulo,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.titulo) = $event)),
                  placeholder: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_n_form_item, {
              label: "Diretório",
              path: "diretorio"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_input, {
                  value: _ctx.model.diretorio,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.diretorio) = $event)),
                  placeholder: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_n_form_item, {
              label: "Descricao",
              path: "descricao"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_input, {
                  value: _ctx.model.descricao,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.descricao) = $event)),
                  placeholder: "",
                  type: "textarea",
                  rows: "5"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_n_form_item, {
              label: "Arquivos detalhados",
              path: "detalhamento"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_switch, {
                  value: _ctx.model.detalhamento,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.detalhamento) = $event))
                }, {
                  checked: _withCtx(() => [
                    _hoisted_2
                  ]),
                  unchecked: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_n_form_item, {
              label: "Status",
              path: "status"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_switch, {
                  value: _ctx.model.status,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.status) = $event))
                }, {
                  checked: _withCtx(() => [
                    _hoisted_4
                  ]),
                  unchecked: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["show", "title", "onPositiveClick"])
  ], 64))
}